export const DATA_FIELDS_ID={
  FIRST_NAME:'firstName',
  LAST_NAME:'lastName',
  EMAIL:'email',
  DOB:'dob',
  STREET_ADDRESS:'streetAddress',
  APARTMENT:'apartment',
  CITY:'city',
  STATE:'state-select',
  POSTAL_CODE:'postalcode',
  INCOME:'income'
}
